export const EVALUATION_LABELS = {
  pending: 'Offen',
  scored: 'Gewertet',
  missed: 'Verpasst',
  void: 'Annulliert',
};

export const REASON_LABELS = {
  exact: 'Exakt',
  goal_difference: 'Tordifferenz',
  tendency: 'Tendenz',
  correct_draw: 'Unentschieden',
  wrong: 'Falsch',
  missed: 'Nicht getippt',
  cancelled: 'Abgesagt',
  no_result: 'Kein Ergebnis',
};

export function formatDeadline(deadlineAt) {
  if (!deadlineAt) return null;
  const d = new Date(deadlineAt);
  const now = new Date();
  const diffMs = d - now;
  if (diffMs <= 0) return 'Abgelaufen';
  const mins = Math.floor(diffMs / 60000);
  if (mins < 60) return `Noch ${mins} Min.`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `Noch ${hours} Std.`;
  return d.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
}
